module.exports = __webpack_public_path__ + "static/locale2-b005587cbaa1f6fb68a15ff5d5adf2f8.png";